<!--
 * @Author: 月魂
 * @Date: 2021-06-04 09:16:31
 * @LastEditTime: 2021-09-16 15:25:23
 * @LastEditors: 月魂
 * @Description:
 * @FilePath: \nepal\src\views\Screen.vue
-->
<template>
  <div class="box">
    <img src="../assets/mobile.jpg" alt="" class="mobile">
    <img src="../assets/pc.jpg" alt="" class="pc">
    <van-button type="default" class="btn" @click="onClick">Enter</van-button>
    <div style="text-align: center; position: absolute; bottom: 20px; width: 100%">
      <a
        href="https://beian.miit.gov.cn"
        rel="nofollow noopener noreferrer"
        target="_blank"
        style="color: #fff; text-decoration: none"
      >
        陕ICP备20012594号-2
      </a>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { Button } from 'vant'
Vue.use(Button)

export default {
  name: 'Screen',
  data() {
    return {}
  },
  methods: {
    onClick() {
      this.$router.push('/index')
    }
  }
}
</script>

<style lang="less" scoped>
.box {
  height: 100%;
  overflow: hidden;
  position: relative;
  .mobile {
    width: 100%;
    height: 100%;
    display: block;
  }
  .pc {
    width: 100%;
    height: 100%;
    display: none;
  }
  @media (min-width: 800px) {
    .mobile {
      display: none;
    }
    .pc {
      display: block;
    }
  }
  .btn {
    position: absolute;
    bottom: 5%;
    right: 5%;
    border-radius: 8px;
  }
}
</style>
